<template>
    <div>
        <h1>Video-Anruf</h1>
    </div>
</template>

<script>
export default {
}
</script>
